package cc.easyandroid.easycompose.core.statekeeper

import kotlinx.serialization.DeserializationStrategy

internal actual fun <T> ByteArray.deserialize(strategy: DeserializationStrategy<T>): T =
    easyComposeJson.decodeFromString(deserializer = strategy, string = decodeToString())